/* eslint-disable arrow-body-style */
import React from 'react';
import classnames from 'classnames';
import './index.scss';

interface IPageProps {
  style: React.CSSProperties;
  className?: string;
  children: React.ReactNode;
}

// 设置容器的外层样式，如：padding
export default (props: IPageProps) => {
  // @ts-ignore
  const { children, className, style, ...resetProps } = props;

  return <div className={classnames('dbb-page-wrap-container', {className })} style={style}>
    {
      React.Children.map(children, child => {
        return React.cloneElement(child, {...resetProps,});
      })
    }
  </div>;
};
